import makeStyles from '@mui/styles/makeStyles';
import Paper from '@mui/material/Paper';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Typography from '@mui/material/Typography';
import theme from 'src/theme/light';

const useStyles = makeStyles((_theme) => ({
  root: {
    backgroundColor: '#e0f2f1',
    borderRadius: 10,
    padding: theme.spacing(2),
    margin: theme.spacing(2),
  },
  icon: {
    color: '#3D8BB6',
    borderRadius: '50%',
    width: 20,
    height: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '5px',
  },
  text: {
    fontWeight: 'bold',
    color: '#395B6E',
  },
  infoText: {
    marginTop: theme.spacing(1),
  },
  container:{
    display: 'flex'
  }
}));

const InfoModal = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.root} elevation={3}>
      <div className={classes.container}>
        <div className={classes.icon}>
          <InfoOutlined />
        </div>
        <Typography className={classes.text}>
          Importante!
        </Typography>
      </div>
      <Typography className={classes.infoText}>
        Os dados preenchidos abaixo serão apresentados na proposta comercial que será enviada ao cliente.
      </Typography>
    </Paper>
  );
};

export default InfoModal;